// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PCheckCircleOutlinedSvg from "@fishx/icons-svg/es/asn/PCheckCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var PCheckCircleOutlined = function PCheckCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PCheckCircleOutlinedSvg
  }));
};

PCheckCircleOutlined.displayName = 'PCheckCircleOutlined';
export default React.forwardRef(PCheckCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PCheckCircleOutlined.js
// module id = 3273
// module chunks = 0